import { request } from '@langlois/request';

export async function isSubscribed ({ commit }, { instanceId, product }) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/subscription/is-subscribed?instanceId=${instanceId}&product=${product}`);

		const response = await request.get(url);

		let isSubscribed = false;

		if (!response.ok) return commit(`isSubscribed`, false);

		isSubscribed = await response.json();
		commit(`isSubscribed`, isSubscribed);
	} catch (error) {
		commit(`isSubscribed`, false);
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while verifying the subscription.`,
			type: `warning`
		}, { root: true });
	}
}
